import {useMemo} from 'react';
import {useQuery} from '@tanstack/react-query';
import {getPerfectStoreList} from '@/services/perfectStore';
import {normalizePerfectStoreList} from '@/pages/PerfectStoreUtils';

export const usePerfectStoreQuery = (enableQuery = true) => {
  const {data, isLoading, isFetching, refetch} = useQuery({
    queryKey: ['PERFECT_STORE_LIST'],
    queryFn: () => getPerfectStoreList('', {}),
    enabled: enableQuery
  });

  const perfectStoreList = useMemo(
    () => normalizePerfectStoreList(data),
    [data]
  );

  return {
    perfectStoreList,
    isLoading,
    isFetching,
    refetch
  };
};
